import script from "./StationsView.vue?vue&type=script&setup=true&lang=js"
export * from "./StationsView.vue?vue&type=script&setup=true&lang=js"

import "./StationsView.vue?vue&type=style&index=0&id=4883261a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4883261a"]])

export default __exports__